<ng-container *tuiLet="color$ | async as color">
    <tui-hosted-dropdown
        *tuiLet="isActive$ | async as isActive"
        #colorSelect
        [content]="cellColorDropdown"
        [tuiDropdownMaxHeight]="999"
        [canOpen]="!!isActive"
    >
        <button
            tuiIconButton
            type="button"
            size="s"
            tuiHintDirection="top-left"
            appearance="icon"
            icon="tuiIconPaintLarge"
            tuiHintDescribe
            [tuiHint]="colorText$ | async"
            [pseudoActive]="colorSelect.open"
            [focusable]="colorSelect.open"
            [disabled]="!isActive"
        ></button>
        <div
            *ngIf="!isBlankColor(color || '')"
            class="t-plate t-plate_paint"
            [style.background]="color"
        ></div>
        <ng-template
            #cellColorDropdown
            let-activeZone
        >
            <tui-palette
                class="t-color-picker"
                [tuiActiveZoneParent]="activeZone"
                [colors]="colors"
                (selectedColor)="setCellColor($event); colorSelect.close()"
            ></tui-palette>
        </ng-template>
    </tui-hosted-dropdown>
</ng-container>
